// Solo ejecutar si estamos en las plantillas permitidas
if (
  window.location.pathname.includes('gripforce-payments-ai') ||
  window.location.pathname.includes('appareil-musculation-pecs-avant-bras-copy-1')
) {
  document.addEventListener('DOMContentLoaded', function() {
    // Buscar todos los formularios de añadir al carrito
    const forms = document.querySelectorAll('form[action="/cart/add"]');
    
    forms.forEach(form => {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        
        // Enviar producto al carrito
        fetch('/cart/add.js', {
          method: 'POST',
          body: new FormData(form)
        })
        .then(response => response.json())
        .then(data => {
          // Obtener los parámetros UTM actuales
          const currentParams = window.location.search;
          
          // URL de destino
          const destinationURL = 'https://www.looney-goods.com/checkout-appareil-b-d9a28--08415';
          
          // Combinar URL con parámetros
          const finalURL = destinationURL + currentParams;
          
          // Redirigir manteniendo los UTMs
          window.location.href = finalURL;
        })
        .catch(error => {
          console.error('Error:', error);
          // Si hay error, enviar el formulario normalmente
          form.submit();
        });
      });
    });
  });
}